module.exports = __webpack_public_path__ + "static/fonts/BMDOHYEON.78ca5e4.woff";